var _g, _defs;

function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) { ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } } return n; }, _extends.apply(null, arguments); }

import * as React from "react";

function SvgSearchAlt(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#search-alt_svg__clip0_1581_3440)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h24v24H0z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.132 15.188h-1.02l-.361-.349a8.38 8.38 0 001.91-6.887c-.607-3.585-3.6-6.448-7.214-6.887C4.988.395.394 4.986 1.065 10.442c.44 3.61 3.304 6.603 6.891 7.209a8.392 8.392 0 006.891-1.909l.349.361v1.02l5.484 5.48c.53.53 1.394.53 1.923 0 .53-.528.53-1.393 0-1.921l-5.471-5.494zm-7.743 0a5.798 5.798 0 01-5.807-5.804A5.798 5.798 0 019.389 3.58a5.798 5.798 0 015.807 5.804 5.798 5.798 0 01-5.807 5.804z",
    fill: "#808489"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "search-alt_svg__clip0_1581_3440"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h24v24H0z"
  })))));
}

export default SvgSearchAlt;